import { Component, Input, OnInit } from '@angular/core';
import { InvoiceInterface, InvoiceStatus } from '@contracts/interfaces/invoice.interface';
import { InvoiceComponent } from '../invoice';


@Component({
  selector: 'app-invoice-standard',
  templateUrl: './invoice-standard.component.html',
  styleUrls: ['./invoice-standard.component.scss', '../../pages/invoice-table.scss']
})
export class InvoiceStandardComponent extends InvoiceComponent implements OnInit {
  @Input()
  invoice: InvoiceInterface;

  defaultInvoice = {
    type: "standard",
    status: InvoiceStatus.Unpaid,
    customer: null,
    number: null,
    custom: "",
    dateCreated: new Date(),
    dateDue: new Date(),
    subTotal: 0,
    total: 0,
    paymentsMade: [],
    pdf: {
      file: "invoice-standard"
    },
    lineItems: [
      {
        item: '',
        desc: '',
        qty: 1,
        price: 0
      }
    ],
    gst: 0,
    isGSTIncluded: true,
    communicationLog: []
  }
}
